"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CMS: 'cms',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  GROWTH_SUITE: 'growth-suite',
  CRM: 'crm',
  CMS_HUB: 'cmsHub'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/ProductsAndPlansNavIds.js
// module id = 99
// module chunks = 5 6